module.exports = __webpack_public_path__ + "img/Infografis_ID_18.fc5701ec.jpg";